import { actionTypes } from './constants';
import { apiCallStatus } from 'helpers/constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { NOTIFICATION_TYPES } from 'sharedComponents/GeneralNotification/constants';
import { ComponentApi } from 'api';
import { getSelectedAsset } from '../../selectors';

const loadMeasurementAction = getApiActionCreator(actionTypes.LOAD_MEASUREMENT);

export const loadMeasurement = () => {
    return async (dispatch, getState) => {
        const state = getState();
        const selectedAsset = getSelectedAsset(state);
        dispatch(loadMeasurementAction(apiCallStatus.LOADING));
        return await ComponentApi.loadMeasurement(selectedAsset.id)
            .then((response) => {
                if (response?.error?.message) {
                    notify(response?.error?.message, NOTIFICATION_TYPES.ERROR);
                } else {
                    notify(translate('ABB.Powertrain.Frontend.ptNotificationMessageRequestSuccess'), NOTIFICATION_TYPES.SUCCESS);
                }
                dispatch(loadMeasurementAction(apiCallStatus.SUCCESS, response));
            })
            .catch((err) => {
                notify(translate('ABB.Powertrain.Frontend.ptNotificationMessageRequestError'), NOTIFICATION_TYPES.ERROR, true);
                dispatch(loadMeasurementAction(apiCallStatus.ERROR, null, err));
                throw err;
            });
    };
};
